import { render, staticRenderFns } from "./UserDataPage.vue?vue&type=template&id=58650950"
import script from "./UserDataPage.vue?vue&type=script&lang=js"
export * from "./UserDataPage.vue?vue&type=script&lang=js"
import style0 from "./UserDataPage.vue?vue&type=style&index=0&id=58650950&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports